<template>
  <aside
    class="my-3 border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl sidenav-flex"
    :class="isRTL ? 'me-2 rotate-caret' : 'ms-2'"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="m-0 navbar-brand" href="/">
        <img :src="logo" class="navbar-brand-img h-100 mx-auto d-block logo-image" :class="{ 'logo-dark-mode': isDark }" alt="main_logo" />
      </a>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import { mapState } from "vuex";
import { useDarkModeSafe } from "@/composables/useDarkModeSafe"; // Rehabilitado con versión optimizada

const logo = require(`@/assets/img/${process.env.VUE_APP_LOGO_FILE}`);

export default {
  name: "index",
  components: {
    SidenavList,
  },
  setup() {
    const { isDark } = useDarkModeSafe(); // Rehabilitado con versión optimizada
    return { 
      isDark // Rehabilitado con versión optimizada
    };
  },
  data() {
    return {
      logo,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
  },
};
</script>

<style scoped>
/* Layout flex para que el aside gestione correctamente el espacio */
.sidenav-flex {
  display: flex !important;
  flex-direction: column !important;
  height: calc(100vh - 2rem) !important;
  max-height: calc(100vh - 2rem) !important;
  overflow: hidden !important;
}

.sidenav-flex .sidenav-header {
  flex-shrink: 0;
}

.sidenav-flex > hr {
  flex-shrink: 0;
  margin-bottom: 0;
}

/* Estilos para el logo */
.logo-image {
  transition: filter 0.3s ease;
}

/* Filtro para modo oscuro - convierte el logo a blanco */
.logo-dark-mode {
  filter: brightness(0) invert(1);
}

/* Hacer el fondo del sidenav transparente - conservar glassmorphism */
.sidenav {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  z-index: 100 !important;
}

/* Override para las máscaras de fondo card-background-mask-* */
.sidenav.card-background-mask-primary::after,
.sidenav.card-background-mask-secondary::after,
.sidenav.card-background-mask-success::after,
.sidenav.card-background-mask-info::after,
.sidenav.card-background-mask-warning::after,
.sidenav.card-background-mask-danger::after,
.sidenav.card-background-mask-light::after,
.sidenav.card-background-mask-dark::after {
  background: transparent !important;
  background-image: none !important;
  opacity: 0 !important;
}

/* Override para el ::before también */
.sidenav.card-background-mask-primary::before,
.sidenav.card-background-mask-secondary::before,
.sidenav.card-background-mask-success::before,
.sidenav.card-background-mask-info::before,
.sidenav.card-background-mask-warning::before,
.sidenav.card-background-mask-danger::before,
.sidenav.card-background-mask-light::before,
.sidenav.card-background-mask-dark::before {
  background: transparent !important;
  opacity: 0 !important;
}

/* Estilos adicionales para el efecto glassmorphism */
.sidenav {
  box-shadow: 0 8px 32px 0 rgba(34, 197, 94, 0.37) !important;
}

/* Mantener transparencia en modo oscuro */
body.dark-mode-active .sidenav {
  background: rgba(17, 25, 40, 0.15) !important;
  backdrop-filter: blur(25px) !important;
  border: 1px solid rgba(255, 255, 255, 0.125) !important;
}
</style>
